﻿import { Grid } from '@mui/material';
import { FC, useEffect } from 'react';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { CustomerCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import { CommunicationPreferenceGrid } from './CommunicationPreferenceGrid';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CPREF } from './communicationPreference.classes';

interface IProps {
    datas?: any;
    labelText?: any;
}

export const CommunicationPreferenceV2: FC<IProps> = ({ datas }) => {
    const [smsHistoryList, setSmsHistoryList] = useState<any>([]);
    const [mailHistoryList, setMailHistoryList] = useState<any>([]);
    const [callHistoryList, setCallHistoryList] = useState<any>([]);
    const [smsHistory, setSmsHistory] = useState<any>([]);
    const [mailHistory, setMailHistory] = useState<any>([]);
    const [callHistory, setCallHistory] = useState<any>([]);
    const [switchStatusObject, setSwitchStatusObject] = useState<any>();
    const [refresh, setRefresh] = useState(false);
    const darkMode: any = useSelector((state: any) => state?.darkMode);
    const refreshList = () => {
        setRefresh((prevLoading) => !prevLoading);
    };
    const { t } = useTranslation();

    const GetCustomerOptInByCustomerId = async () => {
        CustomerCommand.GetCustomerOptInByCustomerId(datas.customer.customerId).then((res: any) => {
            if (res?.data) {
                setSwitchStatusObject({
                    ...switchStatusObject,
                    emailStatus: res.data.emailOptIn,
                    callStatus: res.data.callOptIn,
                    smsStatus: res.data.smsOptIn,
                });
            }
        });
    };
    const GetCustomerOptInByCustomerIdList = async () => {
        let requst: any = {
            customerId: datas.customer.customerId,
        };
        CustomerCommand.GetOptHistoryListV2(requst).then((res: any) => {
            if (res.data) {
                let parseData =
                    res.data.smsHistoryList &&
                    res.data.smsHistoryList?.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.historyDate) || '-',
                            platform: item.sourceName || '-',
                            source: item.platformName || '',
                            state: item.isSmsOptin === true ? t('general.active') : t('general.passive') || '',
                            validateNumber: item.consentPhone || '-',
                            ip: item.ipAddress || '-',
                            device: item.userAgent || '-',
                        };
                    });
                setSmsHistoryList(parseData || []);
                setSmsHistory(res.data.smsInfo);
                let parseDataMail =
                    res.data.mailHistoryList &&
                    res.data.mailHistoryList?.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.historyDate) || '-',
                            platform: item.sourceName || '-',
                            source: item.platformName || '',
                            state: item.isEmailOptin === true ? t('general.active') : t('general.passive') || '',
                            validateNumber: item.consentEmail || '-',
                            ip: item.ipAddress || '-',
                            device: item.longitude || '-',
                        };
                    });
                setMailHistoryList(parseDataMail || []);
                setMailHistory(res.data.mailInfo);

                let parseDataCall =
                    res.data.callHistoryList &&
                    res.data.callHistoryList?.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.historyDate) || '-',
                            platform: item.sourceName || '-',
                            source: item.platformName || '',
                            state: item.isCallOptin === true ? t('general.active') : t('general.passive') || '',
                            ip: item.ipAddress || '-',
                            validateNumber: item.consentPhone || '-',
                        };
                    });
                setCallHistoryList(parseDataCall || []);
                setCallHistory(res.data.callInfo);
            }
        });
    };
    const checkIsStatusChanged = () => {
        if (!switchStatusObject || switchStatusObject === undefined) {
            return false;
        }
        const isEmailStatusChanged =
            mailHistory.optIn !== undefined && switchStatusObject.emailStatus !== mailHistory.optIn;
        const isSmsStatusChanged = smsHistory.optIn !== undefined && switchStatusObject.smsStatus !== smsHistory.optIn;
        const isCallStatusChanged =
            callHistory.optIn !== undefined && switchStatusObject.callStatus !== callHistory.optIn;
        return isEmailStatusChanged || isSmsStatusChanged || isCallStatusChanged;
    };

    const preferenceConfigs = [
        {
            statusName: 'smsStatus',
            infoList: smsHistoryList || [],
            info: smsHistory,
            labelText: 'Sms',
        },
        {
            statusName: 'emailStatus',
            infoList: mailHistoryList || [],
            info: mailHistory,
            labelText: 'Mail',
        },
        {
            statusName: 'callStatus',
            infoList: callHistoryList || [],
            info: callHistory,
            labelText: t('customerInformation.call'),
        },
    ];

    useEffect(() => {
        GetCustomerOptInByCustomerId();
    }, []);

    useEffect(() => {
        GetCustomerOptInByCustomerIdList();
    }, [refresh]);

    useEffect(() => {
        if (checkIsStatusChanged()) {
            let req = {
                customerId: datas.customer.customerId,
                EmailOptIn: switchStatusObject.emailStatus,
                SmsOptIn: switchStatusObject.smsStatus,
                CallOptIn: switchStatusObject.callStatus,
            };
            CustomerCommand.UpdateCustomerOptIn(req).then((res: any) => {
                if (res) {
                    console.info(res.error);
                    if (res.error) {
                        Swal.fire('', res.error, 'error');
                    } else {
                        Swal.fire({
                            icon: res.statuscode == 200 ? 'success' : 'error',
                            timer: 900,
                        });
                    }
                    refreshList();
                }
            });
        }
    }, [switchStatusObject]);

    return (
        <Grid
            className={CPREF.v2Page}
            container
            justifyContent={'space-between'}
            style={{ padding: '1rem', backgroundColor: darkMode?.isDarkMode ? '#111' : 'white' }}
        >
            <p className={CPREF.v2Title} style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                {t('customerInformation.communicationPreferces')}
            </p>
            {switchStatusObject && (
                <Grid
                    className={CPREF.v2GridsContainer}
                    style={{ padding: '1rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    {preferenceConfigs.map((config) => (
                        <CommunicationPreferenceGrid
                            key={config.statusName}
                            switchStatusObject={switchStatusObject}
                            statusName={config.statusName}
                            setSwitchStatusObject={setSwitchStatusObject}
                            infoList={config.infoList}
                            info={config.info}
                            labelText={config.labelText}
                        />
                    ))}
                </Grid>
            )}
        </Grid>
    );
};

